import I18n from "../../I18n";
import { stringifyFilter } from "colbi_web_ui/lib/utils";

const mapCard = (json) => {
    const { RuleID, RuleType, Severity, Description } = json;
    return [
        [{ labels: ["ruleId"], value: RuleID, type: "string", basis: "20%" }],
        [
            {
                labels: ["description"],
                value: Description,
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                labels: ["severity"],
                value: Severity == null || Severity === "" ? "N/A" : I18n.translate(`severity-${Severity}`),
                type: "number",
            },
        ],
        [{ labels: ["ruleType"], value: RuleType, type: "string" }],
        [
            {
                labels: [""],
                value: {
                    id: json.id,
                    customComponent: "PackageAssociationCheckbox",
                },
                type: "customComponent",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        checked: json.selected,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/settings/nc_rules/?filter=${stringifyFilter([
                { column: "RuleID", filters: [{ value: `${json.RuleID}` }] },
            ])}`,
        },
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "20%",
        columnName: "RuleID",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        basis: "50%",
        columnName: "Description",
        sortable: true,
    },
    {
        label: ["Severity"],
        align: "center",
        columnName: "Severity",
        sortable: true,
    },
    {
        label: ["Rule Type"],
        align: "left",
        columnName: "RuleType",
        sortable: true,
    },
    { label: [""], type: "customComponent", align: "right", columnName: "association" },
];

const packagesAssociationRules = {
    map: mapper,
    header,
};

export default packagesAssociationRules;
